export const RENDER_ACTION_BUTTON_DENYLIST = [
    'viz.rectangle',
    'splunk.rectangle',
    'viz.ellipse',
    'splunk.ellipse',
    'viz.text',
    'viz.markdown',
    'splunk.markdown',
];
